import React from "react";

export default function GlobeTalentIcon({ color }: { color: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className="w-5 lg:w-6 h-5 lg:h-6">
            <circle cx="12" cy="12" r="10" />
            <path d="M2 12h20" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            <path d="M6 5.5C7.5 7 9.7 8 12 8s4.5-1 6-2.5" />
            <path d="M6 18.5C7.5 17 9.7 16 12 16s4.5 1 6 2.5" />
        </svg>
    );
}
